const DISMISSED_KEY = christmasCampaignDismissedKey()

export function initChristmasHomepageCampaign(root = document) {
  const banner = root.querySelector('[data-christmas-campaign]')
  if (!banner) {
    return
  }

  const dismissButton = banner.querySelector('[data-christmas-campaign-dismiss]')
  if (!dismissButton) {
    return
  }

  if (wasDismissed()) {
    banner.hidden = true
    return
  }

  dismissButton.addEventListener('click', () => {
    const shouldMoveFocus = document.activeElement === dismissButton
    banner.hidden = true
    if (shouldMoveFocus) {
      focusNextElementAfter(banner)
    }

    try {
      window.localStorage.setItem(DISMISSED_KEY, '1')
    } catch (_error) {
      // Dismissing the banner should still work when storage is unavailable.
    }
  })
}

function wasDismissed() {
  try {
    return window.localStorage.getItem(DISMISSED_KEY) === '1'
  } catch (_error) {
    return false
  }
}

function focusNextElementAfter(element) {
  const followingNode = document.defaultView.Node.DOCUMENT_POSITION_FOLLOWING
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  const nextElement = Array.from(document.querySelectorAll(focusableSelector)).find((candidate) => (
    !element.contains(candidate) && (element.compareDocumentPosition(candidate) & followingNode)
  ))

  nextElement?.focus()
}

function christmasCampaignDismissedKey() {
  const now = new Date()
  const seasonYear = now.getMonth() >= 8 ? now.getFullYear() : now.getFullYear() - 1

  return `christmas_homepage_campaign_dismissed_${seasonYear}`
}
